import { useMemo } from 'react';
import { useDimensions } from '@trinity/chat-components/hooks/useDimensions';
import { MediaOrientation } from '@/enums';

type Params = {
  horizontal: string;
  square: string;
};

export const useNavbarLogo = (logos: Params) => {
  const { width } = useDimensions();

  return useMemo(() => {
    const horizontal = {
      orientation: MediaOrientation.Horizontal,
      url: logos?.horizontal,
    };

    const square = {
      orientation: MediaOrientation.Square,
      url: logos?.square,
    };

    if (width >= 800) {
      if (horizontal.url) return horizontal;
      if (square.url) return square;
      return null;
    } else {
      return square.url
        ? square
        : null;
    }
  }, [
    logos,
    width,
  ]);
};
